import { Program } from "@models/program";
export class ProgramRequest extends Program {
    public requestId: number;
}


// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/requests/program-request.ts